import script from "./AppBrand.vue?vue&type=script&setup=true&lang=js"
export * from "./AppBrand.vue?vue&type=script&setup=true&lang=js"

import "./AppBrand.vue?vue&type=style&index=0&id=5e644cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e644cb2"]])

export default __exports__